import React from "react";

import CalendarTimeGrid from "../components/CalendarTimeGrid";

type Props = {
  focusedDate: Date;
};

const CalendarDayView: React.FC<Props> = ({ focusedDate }) => (
  <CalendarTimeGrid dates={[focusedDate]} />
);

export default CalendarDayView;
